import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="relative flex flex-col items-center justify-center min-h-screen text-center px-4 bg-background-50">
      <h1 className="absolute bottom-0 text-9xl md:text-[12rem] font-black text-background-100 select-none pointer-events-none z-0">
        404
      </h1>
      <div className="relative z-10">
        <span className="w-16 h-16 rounded-full bg-background-200 flex items-center justify-center mx-auto mb-5">
          <i className="ri-leaf-fill text-2xl text-primary-400" />
        </span>
        <h1 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">
          页面未找到
        </h1>
        <p className="mt-3 text-sm md:text-base text-foreground-600">
          你访问的页面可能已被移除，或链接地址有误。
        </p>
        <div className="mt-6 flex flex-wrap justify-center gap-3">
          <Link
            to="/"
            className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-home-line" />
            返回首页
          </Link>
          <Link
            to="/search"
            className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md bg-background-200/70 text-foreground-900 text-sm font-semibold hover:bg-background-300/70 transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-search-line" />
            搜索影视
          </Link>
        </div>
      </div>
    </div>
  );
}